// extracted by mini-css-extract-plugin
export default {"need_edit":"NeedEdit_need_edit__lp46u","info":"NeedEdit_info__AemgF"};